import { render, staticRenderFns } from "./mcInboundEdit.vue?vue&type=template&id=6518b792"
import script from "./mcInboundEdit.vue?vue&type=script&lang=js"
export * from "./mcInboundEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports